// extracted by mini-css-extract-plugin
export var root = "Na4Z";
export var rootBody = "TkFR";
export var rootButton = "N1h0";
export var rootButtonHeading = "ngpC";
export var rootButtons = "_9XYf";
export var rootDescription = "_86JF";
export var rootImage = "_4oL3";
export var rootPicture = "NNJf";